import Validator from 'validatorjs';
import React, { Component } from 'react';

import { FormControl } from '../../../../facturotopia';
import SepomexCodigoPostalSuggestions from '../../../catalogs/SepomexCodigoPostalSuggestions';

class EmisorSectorPrimarioFiscalAddressForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules() {
    return {
      cp: ['required', 'string', 'min:1', 'max:12'],
      direccion: ['required', 'string', 'min:1', 'max:100'],
      numero_exterior: ['string', 'min:1', 'max:55'],
      numero_interior: ['string', 'min:1', 'max:55'],
      colonia: ['required', 'string', 'min:1', 'max:120'],
      municipio: ['required', 'string', 'min:1', 'max:120'],
      estado: ['required', 'string', 'min:1', 'max:30'],
    };
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    this.setState({
      isValid: validator.passes(),
    });

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid: validator.passes(),
    });
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnSuggestionSelect = (name) => (item) => {
    let values = {
      [name]: item?.clave ?? '',
    };

    this.handleOnChange(values);
  };

  render() {
    const { data } = this.props;
    const rules = this.rules();

    return (
      <>
        <SepomexCodigoPostalSuggestions
          name="cp"
          id="cp"
          label="Código Postal"
          help=""
          minLength="5"
          maxLength="5"
          rules={rules.cp}
          value={data.cp}
          onSelect={this.handleOnSuggestionSelect('cp')}
        />

        <FormControl
          type="text"
          label="Calle"
          name="direccion"
          placeholder=""
          help=""
          minLength="1"
          maxLength="100"
          rules={rules.direccion}
          value={data.direccion}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="text"
          label="Número Exterior"
          name="numero_exterior"
          placeholder="1A"
          help=""
          minLength="1"
          maxLength="55"
          rules={rules.numero_exterior}
          value={data.numero_exterior}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="text"
          label="Número Interior"
          name="numero_interior"
          placeholder="B"
          help=""
          minLength="1"
          maxLength="55"
          rules={rules.numero_interior}
          value={data.numero_interior}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="text"
          label="Colonia"
          name="colonia"
          placeholder="Bugambilias"
          help=""
          minLength="1"
          maxLength="120"
          rules={rules.colonia}
          value={data.colonia}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="text"
          label="Municipio"
          name="municipio"
          placeholder="Benito Juárez"
          help=""
          minLength="1"
          maxLength="120"
          rules={rules.municipio}
          value={data.municipio}
          onChange={this.handleOnChange}
        />

        <FormControl
          type="text"
          label="Estado"
          name="estado"
          placeholder="Ciudad de méxico"
          casing={'upper'}
          help=""
          minLength="1"
          maxLength="30"
          rules={rules.estado}
          value={data.estado}
          onChange={this.handleOnChange}
        />
      </>
    );
  }
}

export default EmisorSectorPrimarioFiscalAddressForm;
